import React, { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

const AddPainting = () => {
  const [painting, setPainting] = useState({
    title: "",
    artistName: "",
    year: "",
    medium: "",
    dimensions: "",
    description: "",
    category: "",
    price: "",
    image: null,
    availability: "",
    location: "",
    tags: "",
    exhibitionHistory: "",
    condition: "",
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setPainting({
      ...painting,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Painting submitted: ", painting);
  };

  return (
    <div className="dashboard-pages-padding">
      {/* <h1>My Profile</h1> */}

      <Row className="justify-content-md-center add-painting-form">
        <h1 style={{ marginLeft: '10px' }}>Add Painting</h1>
        <Col md={6}>
          <Form.Group controlId="formTitle">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter painting title"
              name="title"
              value={painting.title}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="formArtistName">
            <Form.Label>Artist Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter artist name"
              name="artistName"
              value={painting.artistName}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="formYear">
            <Form.Label>Year</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter year of creation"
              name="year"
              value={painting.year}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="formMedium">
            <Form.Label>Medium</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter medium (e.g., oil on canvas)"
              name="medium"
              value={painting.medium}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="formDimensions">
            <Form.Label>Dimensions</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter dimensions (e.g., 24 x 36 inches)"
              name="dimensions"
              value={painting.dimensions}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="formPrice">
            <Form.Label>Price</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter price"
              name="price"
              value={painting.price}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="formImage">
            <Form.Label>Image Upload</Form.Label>
            <Form.Control type="file" name="image" onChange={handleChange} />
          </Form.Group>
          <Form.Group controlId="formCategory">
            <Form.Label>Category</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter category (e.g., Abstract, Realism)"
              name="category"
              value={painting.category}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group controlId="formDescription">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter description of the painting"
              name="description"
              value={painting.description}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>

      </Row>
      <button className="save-profile-btn">Add Painting</button>

    </div>
  );
};

export default AddPainting;
